<script setup lang="ts">
import { PropType } from 'vue'
import ReviewPreviewCard from '~/components/objects/ReviewClub/PreviewCard/ReviewPreviewCard.vue'
import Review from '~/models/ReviewClub/Review'

defineProps({
    reviewListData: {
        type: Array as PropType<Review[]>,
        default: () => [],
    },
    maxCount: {
        type: Number,
        default: Infinity,
    },
})

const showReviewDetail = () => {
    useNuxtApp().$bus.$emit('showReviewDetail')
    useNuxtApp().$bus.$emit('showReviewDetailWeTested')
}
</script>

<template>
    <div class="review-club-overview-list mt-4" :class="{ 'review-club-overview-list--row': reviewListData.length !== 1 }">
        <template v-for="(review, index) in reviewListData">
            <ReviewPreviewCard v-if="index + 1 <= maxCount" :key="index" :review="review" />
        </template>
    </div>
    <div v-if="maxCount !== Infinity && reviewListData.length > maxCount" class="text-center mb-3 mt-3">
        <button class="btn btn-outline-primary" @click="showReviewDetail">
            {{ $t('reviewClub.readAllReviewFromOurCustomers') }} ({{ reviewListData.length }})
        </button>
    </div>
</template>

<style lang="scss" scoped>
.review-club-overview-list--row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 15px;
    flex-wrap: wrap;

    &:deep(.review-club-overview) {
        @media (min-width: 768px) {
            flex-basis: 49%;
        }
    }
}
</style>
